interface ErrorStateProps {
  message: string
  title?: string
}

export function ErrorState({ message, title = 'Error' }: ErrorStateProps) {
  return (
    <div style={{ textAlign: 'center', padding: 'var(--space-xl) 0' }}>
      <div style={{ 
        width: '64px',
        height: '64px',
        borderRadius: 'var(--radius-full)',
        background: 'var(--error-bg)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto var(--space-lg)',
      }}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="var(--error)" strokeWidth="2" />
          <path d="M12 8V12" stroke="var(--error)" strokeWidth="2" strokeLinecap="round" />
          <circle cx="12" cy="16" r="1" fill="var(--error)" />
        </svg>
      </div>
      
      <h2 style={{ 
        fontSize: '20px', 
        fontWeight: 600, 
        marginBottom: 'var(--space-sm)',
        color: 'var(--text)',
      }}>
        {title}
      </h2>
      
      <p style={{ 
        color: 'var(--text-muted)', 
        fontSize: '15px',
        maxWidth: '280px',
        margin: '0 auto',
        lineHeight: 1.5,
      }}>
        {message}
      </p>
      
      <div style={{ marginTop: 'var(--space-xl)' }}>
        <a 
          href="https://carbon.to" 
          className="btn btn-secondary"
          style={{ textDecoration: 'none' }}
        >
          Learn about Carbon
        </a>
      </div>
    </div>
  )
}
